import { CorpJobCounts } from '@scale/shared/types/api/corp-api/corpJobs/CorpJobCounts';
import { INotificationSeverity } from '@scale/shared/types/notifications/notification';
import { IUserJson } from '@scale/shared/types/user';
import SearchDialog from 'corp/components/Layout/SearchDialog';
import { UpdateStaffing } from 'corp/views/UpdateStaffingReminder';
import Spinner from 'design-system/Spinner';
import lscache from 'lscache';
import React, { Suspense, useCallback, useState } from 'react';
import { useApiFetchGetRequest } from 'react-scale/hooks/useApiFetchGetRequest';
import useShortcut from 'react-scale/hooks/useShortcut';
import Notifications from './Notifications';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

interface CorpLayoutProps {
  children: React.ReactNode;
  user: IUserJson;
}

const CorpLayout: React.FC<CorpLayoutProps> = ({ children, user }) => {
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const [collapsedNotifications, setCollapsedNotifications] = React.useState<boolean>(true);
  const [notificationCount, setNotificationCount] = React.useState<
    Record<keyof typeof INotificationSeverity, number>
  >({
    info: 0,
    warning: 0,
    action_required: 0,
    urgent: 0,
  });

  const onToggleCollapsedNotifications = React.useCallback(() => {
    setCollapsedNotifications(value => !value);
  }, [setCollapsedNotifications]);

  const handleClickSearch = () => {
    setShowSearchDialog(true);
  };

  const handleShortcut = useCallback(() => {
    setShowSearchDialog(true);
  }, []);

  useShortcut({
    trigger: 'command+k, command+j, ctrl+k, ctrl+j',
    action: handleShortcut,
  });
  const lastChecked = lscache.get('corpJobsLastAccessed')
    ? lscache.get('corpJobsLastAccessed')
    : null;
  const corpJobCountsRequest = useApiFetchGetRequest<CorpJobCounts>(
    `corp-api/jobs/counts?lastChecked=${encodeURIComponent(lastChecked)}`,
  );
  return (
    <>
      <div className="container-corp">
        <TopBar
          onClickSearch={handleClickSearch}
          user={user}
          jobCounts={corpJobCountsRequest.response}
          notificationCount={notificationCount}
          onToggleCollapsedNotifications={onToggleCollapsedNotifications}
        />
        <div className="layout">
          <Sidebar />
          <div
            className="content"
            style={{
              marginTop: '60px',
              // TODO(arno): Bad, instead content inside should choose to have uniform padding
              padding: '32px',
            }}
          >
            <Suspense fallback={<Spinner />}>{children}</Suspense>
          </div>
          <Notifications
            collapsed={collapsedNotifications}
            setNotificationCount={setNotificationCount}
          />
        </div>
      </div>

      <style jsx>{`
        .container-corp {
          flex-grow: 1;
          overflow: auto;
          display: flex;
          flex-direction: column;
        }

        .layout {
          height: 100%;
          flex-grow: 1;
          display: flex;
          flex-direction: row;
        }

        .content {
          flex-grow: 1;
          display: flex;
          overflow: auto;
          flex-direction: column;
        }
      `}</style>

      <SearchDialog open={showSearchDialog} onClose={() => setShowSearchDialog(false)} />
      <UpdateStaffing user={user} />
    </>
  );
};

export default CorpLayout;
